'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import { Breadcrumbs } from '../../_components/Breadcrumps'
import Main from './_blocks/Main'
import Decision from './_blocks/Decision'
import ForWhom from './_blocks/ForWhom'
import Reserve from './_blocks/Reserve'
import WhyChooseUs from './_blocks/WhyChooseUs'
import Instrument from '../_blocks/Instrument'
import CtaBannerCentered from '../_blocks/CtaBannerCentered'
import ThreeModels from './_blocks/ThreeModels'
import Tariffs from './_blocks/Tariffs'
import AboutTask from './_blocks/AboutTask'
import Clients from '../_blocks/Clients'
import Industries from '../_blocks/Industries'
import Portfolio from '@/app/portfolio/[portfolio]/_blocks/Portfolio'
import Contact from '@/app/_blocks/Main_redesign/Contact'
import styles from './styles.module.css'

export default function OutstaffingPage() {
	return (
		<>
			<Breadcrumbs className={styles.breadcrumbs} />
			<main className={styles.main}>
				<Main />
				<Decision />
				<ForWhom />
				<div className={styles.reserveBlock}>
					<Reserve />
				</div>
				<WhyChooseUs />
				<AnimatedSection animation='slideUp'>
					<div className={styles.instrumentBlock}>
						<Instrument />
					</div>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<div className={styles.ctaBannerBlock}>
						<CtaBannerCentered />
					</div>
				</AnimatedSection>
				<ThreeModels />
				<Tariffs />
				<AnimatedSection animation='slideUp'>
					<div className={styles.aboutTaskBlock}>
						<AboutTask />
					</div>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<div className={styles.clientsBlock}>
						<Clients />
					</div>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<div className={styles.industriesBlock}>
						<Industries />
					</div>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<div className={styles.portfolioBlock}>
						<Portfolio />
					</div>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<div className={styles.contactBlock}>
						<Contact />
					</div>
				</AnimatedSection>
			</main>
		</>
	)
}
